<script lang="ts" setup>
const {
  comboCustomized,
} = storeToRefs(useCommerceStore())

// Toggle for testing native vs PrimeVue accordion
const useNativeAccordion = ref(true) // Set to true to use native implementation
</script>

<template>
  <div class="h-full">
    <div
      class="lg:grid lg:h-full"
      :class="comboCustomized ? 'lg:grid-cols-10' : ''"
    >
      <div
        class="customization"
        :class="{
          'p-2 shadow-xl overflow-y-scroll col-span-5': comboCustomized,
          'hidden': !comboCustomized,
        }"
      >
        <PublicStoreCombosCustomFormNative v-if="useNativeAccordion" />
        <PublicStoreCombosCustomForm v-else />
      </div>
      <div
        id="product-details"
        class="relative"
        :class="{
          'col-span-5': comboCustomized,
        }"
      >
        <PublicStoreCombosPlain />
      </div>
    </div>
  </div>
</template>
